import React from "react";
import styled from "styled-components";
import * as u from "../utils";

export function LinkRead(props) {
  return (
    <S.StaticSpan
      target="_blank"
      href={props.decoratedText}
      data-offset-key={props.offsetKey}
    >
      {props.decoratedText}
    </S.StaticSpan>
  );
}

export function link() {
  return function strategy(block, cb) {
    const LINK_REGEX = /http(\S+)/g;
    const text = block.getText();
    let matchArr, start;
    while ((matchArr = LINK_REGEX.exec(text)) !== null) {
      start = matchArr.index;
      cb(start, start + matchArr[0].length);
    }
  };
}

const S = {};

S.Container = styled.span`
  color: rgba(98, 177, 254, 1);
  background-color: rgba(98, 177, 254, 0.2);
  border-radius: 3px;
  padding: 0px 2px;
  span {
    font-family:
      HK Grotesk,
      sans-serif;
  }
`;

S.StaticSpan = styled.a`
  color: ${u.colours.charcoal};
  cursor: pointer;
  span {
    font-family:
      HK Grotesk,
      sans-serif;
  }
  :hover {
    color: rgb(46, 137, 255);
  }
`;
